
import React from 'react';
import { Client } from './data/clientTypes';
import ClientLogo from './ClientLogo';
import { cn } from '@/lib/utils';

interface LogoCarouselProps {
  clients: Client[];
  direction?: 'left' | 'right';
  speed?: number;
  className?: string;
  grayscale?: boolean; // New prop to control grayscale effect
}

const LogoCarousel: React.FC<LogoCarouselProps> = ({
  clients,
  direction = 'left',
  speed = 8,
  className,
  grayscale = false // Default to no grayscale
}) => {
  // Calculate animation duration based on speed (lower number = slower)
  const duration = 100 / speed; 
  
  // Triple the clients array to ensure smooth continuous scrolling
  const triplicatedClients = [...clients, ...clients, ...clients];
  
  return (
    <div className={cn("relative overflow-hidden w-full", className)}>
      <div 
        className={cn(
          "flex gap-8", 
          direction === 'left' ? "animate-carousel-left" : "animate-carousel-right"
        )}
        style={{ 
          animationDuration: `${duration}s`,
          animationTimingFunction: 'linear',
          animationIterationCount: 'infinite',
          animationPlayState: 'running',
          width: 'fit-content',
          paddingLeft: '1rem',
          paddingRight: '1rem'
        }}
      >
        {triplicatedClients.map((client, i) => (
          <div 
            key={`${client.id}-${i}`} 
            className="flex-shrink-0 transition-transform hover:scale-105"
          >
            <ClientLogo 
              client={client} 
              className={cn(
                "w-40 h-20 transition-all duration-300",
                grayscale ? "grayscale hover:grayscale-0" : ""
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoCarousel;
